import { type GraphQLGatewayLinks } from './constants';

const graphqlGatewayQueryLinkOverrideMap: Record<string, GraphQLGatewayLinks> = {
  StaffSessionsV2AuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  EnterpriseCourseProgramQuery: 'gatewayWrapperGql',
  MobileHeaderProgramQuery: 'gatewayWrapperGql',
  OpenCourseMembershipsV1Query: 'gatewayWrapperGql',
  EnterprisePrivateSessionsQuery: 'gatewayWrapperGql',
  CourseDataQuery: 'gatewayWrapperGql',
  AdminContractDetailsQuery: 'gatewayWrapperGql',
  TspCourseRecommendationsQueryLight: 'gatewayWrapperGql',
  TargetSkillProfileUserStatesQuery: 'gatewayWrapperGql',
  ProgramMembershipsByUserQuery: 'gatewayWrapperGql',
  CollectionAdminSUQuery: 'gatewayWrapperGql',
  SkillBasedRecommendationsQuery: 'gatewayWrapperGql',
  CollectionTableMetadataQuery: 'gatewayWrapperGql',
  getUnderlyingProductId: 'gatewayWrapperGql',
  TSPQuery: 'gatewayWrapperGql',
  UserProductTransaction: 'gatewayWrapperGql',
  TeammateReviewAuthoringQuery: 'gatewayWrapperGql',
  CourseAutoenrollmentModalQuery: 'gatewayWrapperGql',
  CredentialTrackQuery: 'gatewayWrapperGql',
  CuratedCollectionDetailsQuery: 'gatewayWrapperGql',
  Images: 'gatewayWrapperGql',
  SDPRichEntityQuery: 'gatewayWrapperGql',
  OrgLandingProgramMembershipsQuery: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataActivitySetActivitiesQuery: 'gatewayWrapperGql',
  ProgramLevelRecommendationsQuery: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataActivitySetCandidateItemsQuery: 'gatewayWrapperGql',
  TeamEditViewQuery: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataQuery: 'gatewayWrapperGql',
  ProgramDraftQuery: 'gatewayWrapperGql',
  MegaMenuQuery: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataActivitySetQuery: 'gatewayWrapperGql',
  PublicPromotionInfoProductCollectionFinder: 'gatewayWrapperGql',
  CourseBuilderCourseRating: 'gatewayWrapperGql',
  ProgramsAndRostersByProgramsQuery: 'gatewayWrapperGql',
  GetAllProgramCurriculumContentsQuery: 'gatewayWrapperGql',
  GetAllContractsForOrgQuery: 'gatewayWrapperGql',
  S12nCoursesByIdQuery: 'gatewayWrapperGql',
  enterprisePaymentWalletQuery: 'gatewayWrapperGql',
  OnDemandLearnerSummariesForStaffV1Query: 'gatewayWrapperGql',
  MegaMenuSkillDataQuery: 'gatewayWrapperGql',
  TSPCollectionListQuery: 'gatewayWrapperGql',
  S12nMetadataForS12nRecommendations: 'gatewayWrapperGql',
  ProductQuery: 'gatewayWrapperGql',
  ProductsOwnedById: 'gatewayWrapperGql',
  ProductItemDetails: 'gatewayWrapperGql',
  EnterpriseProgramSessionAssociationsQuery: 'gatewayWrapperGql',
  AuthoringTeamworkScopeIdByNonHighEngagementGroupQuery: 'gatewayWrapperGql',
  orgMembershipQuery: 'gatewayWrapperGql',
  PromoCodesFinderQuery: 'gatewayWrapperGql',
  UpdateAuthoringTeamworkMetadataActivitySetQuery: 'gatewayWrapperGql',
  PersonalizationSessionsV2AuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  RecentCompletedPathway: 'gatewayWrapperGql',
  HasProgramSummaryQuery: 'gatewayWrapperGql',
  UnifiedEnterpriseOnDemandSpecialziationsMembershipsQuery: 'gatewayWrapperGql',
  StaffSessionsVgatewayWrapperGqlAuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  getCourseBySlug: 'gatewayWrapperGql',
  InternalPublicPromotionInfoProductCollectionFinder: 'gatewayWrapperGql',
  GetAllProgramDraftStatusesQuery: 'gatewayWrapperGql',
  EnterpriseTargetSkillProfileQuery: 'gatewayWrapperGql',
  RelatedCoursesQuery: 'gatewayWrapperGql',
  FindByPromoCodeQuery: 'gatewayWrapperGql',
  TeamworkLearnerTeamsVgatewayWrapperGqlQuery: 'gatewayWrapperGql',
  CdsTeammateReviewCoverQuery: 'gatewayWrapperGql',
  S12nNamesByIds: 'gatewayWrapperGql',
  getCourseTotals: 'gatewayWrapperGql',
  PeerSessionsVgatewayWrapperGqlAuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  CurriculumSummariesDataLoaderQuery: 'gatewayWrapperGql',
  MegaMenuDataQuery: 'gatewayWrapperGql',
  PaymentsProductSkuQuery: 'gatewayWrapperGql',
  ProgramCurriculumDomainsQuery: 'gatewayWrapperGql',
  SgatewayWrapperGqlnMetadataForSgatewayWrapperGqlnRecommendations: 'gatewayWrapperGql',
  VideoCoursesQuery: 'gatewayWrapperGql',
  PurchaseCredentialTrackQuery: 'gatewayWrapperGql',
  ProgramShellContractQuery: 'gatewayWrapperGql',
  AllCourseReviews: 'gatewayWrapperGql',
  DirectoryDomainsAndSubdomainsQuery: 'gatewayWrapperGql',
  TaxEstimatesQuery: 'gatewayWrapperGql',
  LinkedCoursesQuery: 'gatewayWrapperGql',
  getS12nModalData: 'gatewayWrapperGql',
  ProgramProductMetadataGetQuery: 'gatewayWrapperGql',
  VLPCourseMaterialsQuery: 'gatewayWrapperGql',
  AdminPagePermissionQuery: 'gatewayWrapperGql',
  ThirdPartyOrgMultiGetQuery: 'gatewayWrapperGql',
  CommonProgramProductMetadataMultiGetQuery: 'gatewayWrapperGql',
  ProductsContainerCourseQuery: 'gatewayWrapperGql',
  ProgramCreationPageQuery: 'gatewayWrapperGql',
  XdpCourseDataQuery: 'gatewayWrapperGql',
  TopRecommendationsForSkillSetCustomQuery: 'gatewayWrapperGql',
  UserProductTransactions: 'gatewayWrapperGql',
  LOHPCollectionQuery: 'gatewayWrapperGql',
  EnterpriseHomePageQuery: 'gatewayWrapperGql',
  ProgramDetailsMainQuery: 'gatewayWrapperGql',
  membershipQuery: 'gatewayWrapperGql',
  EnterpriseProgramsListQuery: 'gatewayWrapperGql',
  AcademicDisciplineBannerFirstNameQuery: 'gatewayWrapperGql',
  GetEnrollmentByUserIdAndProductIdQuery: 'gatewayWrapperGql',
  SgatewayWrapperGqlgatewayWrapperGqlnSessionDatesQuery: 'gatewayWrapperGql',
  degreeEnrollmentChecklistsV1Query: 'gatewayWrapperGql',
  ThirdPartyOrganizationNoticesQuery: 'gatewayWrapperGql',
  OnDemandLearnerSummariesForStaffVgatewayWrapperGqlQuery: 'gatewayWrapperGql',
  SettingsQuery: 'gatewayWrapperGql',
  CourseAutoenrollmentSessionDatesQuery: 'gatewayWrapperGql',
  FinAidProductCardInfoOnDemandCoursesV1Resource: 'gatewayWrapperGql',
  EnterprisePartnersQuery: 'gatewayWrapperGql',
  AuthoringTeamworkScopeIdByHighEngagementGroupQuery: 'gatewayWrapperGql',
  SlackPartnersQuery: 'gatewayWrapperGql',
  EnrollmentAndUsersQuery: 'gatewayWrapperGql',
  DegreeLearnerMembershipsQuery: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataActivitySetActivityQuery: 'gatewayWrapperGql',
  SubscriptionsQuery: 'gatewayWrapperGql',
  DirectoryPageSpecializationsQuery: 'gatewayWrapperGql',
  EnterpriseProgramWithSkillsetsQuery: 'gatewayWrapperGql',
  PortfolioProjectsByIdsQuery: 'gatewayWrapperGql',
  ProgramsAndRostersByOrganizationQuery: 'gatewayWrapperGql',
  PromotionsGet: 'gatewayWrapperGql',
  ReviewsPage: 'gatewayWrapperGql',
  AdminDashboardPageBaseQuery: 'gatewayWrapperGql',
  VLPHelpfulReviewsQuery: 'gatewayWrapperGql',
  AuthoringTeamsVgatewayWrapperGqlQuery: 'gatewayWrapperGql',
  HasCourseraLabsQuery: 'gatewayWrapperGql',
  EnterpriseCourseMetadataQuery: 'gatewayWrapperGql',
  CampusProgramEnrollmentSettingsQuery: 'gatewayWrapperGql',
  S12nProductSkusForFinaid: 'gatewayWrapperGql',
  EnterprisePromotionQuery: 'gatewayWrapperGql',
  CurriculumCollectionsQuery: 'gatewayWrapperGql',
  LinkedEnterpriseProgramsQuery: 'gatewayWrapperGql',
  FindByEnterprisePromotionIdQuery: 'gatewayWrapperGql',
  EnterpriseContractTransactionsQuery: 'gatewayWrapperGql',
  GdprMembership: 'gatewayWrapperGql',
  AdminContractsQuery: 'gatewayWrapperGql',
  S12nSessionDatesQuery: 'gatewayWrapperGql',
  ThirdPartyOrganizationQuery: 'gatewayWrapperGql',
  PrivateSessionDrawerMetadataQuery: 'gatewayWrapperGql',
  DegreeResourceInfo: 'gatewayWrapperGql',
  ThirdPartyOrganizationsQuery: 'gatewayWrapperGql',
  EnterpriseSgatewayWrapperGqlnRecommendationsForSkillId: 'gatewayWrapperGql',
  TopDegreePathways: 'gatewayWrapperGql',
  EnterpriseProductConfigurationMetadataQuery: 'gatewayWrapperGql',
  ContractDetailsQuery: 'gatewayWrapperGql',
  CourseInfoQuery: 'gatewayWrapperGql',
  PromotionDetailsQuery: 'gatewayWrapperGql',
  EnterpriseDetailsAppQuery: 'gatewayWrapperGql',
  EnterpriseBrowseAcademicDisciplinesCollectionQuery: 'gatewayWrapperGql',
  EnterpriseS12nRecommendationsForSkillId: 'gatewayWrapperGql',
  ChooseContractsQuery: 'gatewayWrapperGql',
  ContentConfirmationQuery: 'gatewayWrapperGql',
  TSPCourseRecommendationsCollectionQuery: 'gatewayWrapperGql',
  checkSwitcherProgram: 'gatewayWrapperGql',
  ProgramProductEnterpriseMetadataMultiGetQuery: 'gatewayWrapperGql',
  getCourseData: 'gatewayWrapperGql',
  getOnDemandCourseData: 'gatewayWrapperGql',
  TeamworkLearnerTeamsV1Query: 'gatewayWrapperGql',
  OnDemandLearnerMaterialsQuery: 'gatewayWrapperGql',
  EnterpriseProgramSummariesQuery: 'gatewayWrapperGql',
  EnterpriseCourseRecommendationsForSkillId: 'gatewayWrapperGql',
  PartnerMembershipsQuery: 'gatewayWrapperGql',
  EnterpriseSgatewayWrapperGqlgatewayWrapperGqlnRecommendationsForSkillId: 'gatewayWrapperGql',
  FinancialAidCoursesV1Resource: 'gatewayWrapperGql',
  EnrichmentQuery: 'gatewayWrapperGql',
  OnDemandSpecializations: 'gatewayWrapperGql',
  AnalyticsContractsQuery: 'gatewayWrapperGql',
  PrivateSessionCurriculumSummariesDataLoaderQuery: 'gatewayWrapperGql',
  ChooseContractQuery: 'gatewayWrapperGql',
  GetIdVerificationHistory: 'gatewayWrapperGql',
  GetBaseCertificateSlugsQuery: 'gatewayWrapperGql',
  TopRecommendationsForSkillSetQuery: 'gatewayWrapperGql',
  AuthoringWorkspaceTemplate: 'gatewayWrapperGql',
  SavedProductsQuery: 'gatewayWrapperGql',
  ProgramsQuery: 'gatewayWrapperGql',
  ProgramDetailsSkillSetsQuery: 'gatewayWrapperGql',
  ObjectiveSummaryQuery: 'gatewayWrapperGql',
  ProgramSSOBannerQuery: 'gatewayWrapperGql',
  PreviewSkillCollectionListBySkillQuery: 'gatewayWrapperGql',
  CourseDetailsQueryVlp: 'gatewayWrapperGql',
  LearnerCourseScheduleRunningAndUpcomingQuery: 'gatewayWrapperGql',
  DomainGetAllQuery: 'gatewayWrapperGql',
  FinancialAidApplicationsByUserAndProduct: 'gatewayWrapperGql',
  ProgramBySlugQuery: 'gatewayWrapperGql',
  LoggedOutProgramHeaderQuery: 'gatewayWrapperGql',
  InstructorProfileViewerByShortNameQuery: 'gatewayWrapperGql',
  InternalThirdPartyOrganizationPageQuery: 'gatewayWrapperGql',
  InstructorProfileViewerByIdQuery: 'gatewayWrapperGql',
  CDPRichEntityQuery: 'gatewayWrapperGql',
  CourseraPlusPrepaidOwnershipDaysQuery: 'gatewayWrapperGql',
  Subscription: 'gatewayWrapperGql',
  SingleEnterpriseContractQuery: 'gatewayWrapperGql',
  nextStepQuery: 'gatewayWrapperGql',
  EnterpriseProgramsByThirdPartyOrganizationIdQuery: 'gatewayWrapperGql',
  GetCoursesWithSessionsQuery: 'gatewayWrapperGql',
  EnterpriseProgramBySlugQuery: 'gatewayWrapperGql',
  FinancialAidCourse: 'gatewayWrapperGql',
  MasterTrackEntityQuery: 'gatewayWrapperGql',
  PdpPageQueryById: 'gatewayWrapperGql',
  FetchProductOverviewQuery: 'gatewayWrapperGql',
  DirectoryPageCollectionsQuery: 'gatewayWrapperGql',
  CourseDetailsCourseVgatewayWrapperGqlDataQuery: 'gatewayWrapperGql',
  CourseDetailsCourseV1DataQuery: 'gatewayWrapperGql',
  XdpDataQuery: 'gatewayWrapperGql',
  AnnouncementSessionsV2AuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  GenericProductVariantQuery: 'gatewayWrapperGql',
  ProgramCurriculumProductsQuery: 'gatewayWrapperGql',
  SFCVLPCourseMaterialsQuery: 'gatewayWrapperGql',
  GetProgramCurriculumData: 'gatewayWrapperGql',
  AccomplishmentsPaymentsRecommendationQuery: 'gatewayWrapperGql',
  ProfessionalCertificatesData: 'gatewayWrapperGql',
  DegreeHomeAppQuery: 'gatewayWrapperGql',
  CourseTypeMetadataByCourseIdQuery: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataActivitySetTeamQuery: 'gatewayWrapperGql',
  AiReviewSummaryQuery: 'gatewayWrapperGql',
  PartnerListingPageQuery: 'gatewayWrapperGql',
  SessionsVgatewayWrapperGqlAuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  OrgLandingProgramsQuery: 'gatewayWrapperGql',
  AuthoringTeamsV1Query: 'gatewayWrapperGql',
  AssemberRosterQuery: 'gatewayWrapperGql',
  PortfolioProjectQuery: 'gatewayWrapperGql',
  enterpriseContractQuery: 'gatewayWrapperGql',
  AuthoringUserCoursePermissionsQuery: 'gatewayWrapperGql',
  PublicPromotionInfoLandingPageBannerFinder: 'gatewayWrapperGql',
  getTwoDegreesData: 'gatewayWrapperGql',
  MiniCDPQuery: 'gatewayWrapperGql',
  EnterpriseProgramS12nSessionAssociationsQuery: 'gatewayWrapperGql',
  MiniSDPQuery: 'gatewayWrapperGql',
  GdprSettingsQuery: 'gatewayWrapperGql',
  EnterpriseSubjectMatterExpertsQuery: 'gatewayWrapperGql',
  CuiEnterpriseProgramSessionAssociationsQuery: 'gatewayWrapperGql',
  AnnouncementSessionsVgatewayWrapperGqlAuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  GetEnrollableSessionsQuery: 'gatewayWrapperGql',
  ProgramForDPAQuery: 'gatewayWrapperGql',
  CdsTMRGradesQuery: 'gatewayWrapperGql',
  ThirdPartyOrganizationByPartnerIdQuery: 'gatewayWrapperGql',
  VLPCourseDetailsQuery: 'gatewayWrapperGql',
  CourseDetailsInstructorsQuery: 'gatewayWrapperGql',
  ProgramSkillSetsSelectionQuery: 'gatewayWrapperGql',
  FullSkillCollectionListBySkillQuery: 'gatewayWrapperGql',
  PromotionsFindByTypes: 'gatewayWrapperGql',
  LinkedAtomInfoQuery: 'gatewayWrapperGql',
  EnterpriseProgramSessionAssociationsByProgramsAndCourseQuery: 'gatewayWrapperGql',
  GetAllDomains: 'gatewayWrapperGql',
  CDPSchemaMarkupQuery: 'gatewayWrapperGql',
  ProgramsByOrgSlugQuery: 'gatewayWrapperGql',
  S12nPreEnrollmentProductSkus: 'gatewayWrapperGql',
  IdVerificationsQuery: 'gatewayWrapperGql',
  PrivateAuthoringQuery: 'gatewayWrapperGql',
  AuthoringTeamworkListActivitySetsQuery: 'gatewayWrapperGql',
  AdminUserPermissionsQuery: 'gatewayWrapperGql',
  GetLearnerVerificationRequirements: 'gatewayWrapperGql',
  getCourseCards: 'gatewayWrapperGql',
  EnterpriseProductRecommendationsQuery: 'gatewayWrapperGql',
  ProgramAlternativeEmailModalQuery: 'gatewayWrapperGql',
  ProgramAddEmailModalQuery: 'gatewayWrapperGql',
  InternalPublicPromotionInfoProductItemFinder: 'gatewayWrapperGql',
  XdpSpecializationDataQuery: 'gatewayWrapperGql',
  EnrollmentChoiceModalProductDescriptionQuery: 'gatewayWrapperGql',
  SkillCollectionListBySkillSetQuery: 'gatewayWrapperGql',
  DomainSubdomainQuery: 'gatewayWrapperGql',
  PublicPromotionInfoProductPageBannerFinder: 'gatewayWrapperGql',
  CdsTeammateReviewQuery: 'gatewayWrapperGql',
  UserSubscriptions: 'gatewayWrapperGql',
  EnterpriseProgramSgatewayWrapperGqlnSessionAssociationsQuery: 'gatewayWrapperGql',
  GoogleSchemaInfo: 'gatewayWrapperGql',
  SgatewayWrapperGqlnSessionDatesQuery: 'gatewayWrapperGql',
  SpecializationInfoQuery: 'gatewayWrapperGql',
  DirectoryPageCoursesQuery: 'gatewayWrapperGql',
  SavedContainerCourseQuery: 'gatewayWrapperGql',
  getDegreesData: 'gatewayWrapperGql',
  PromotionUserEligibleRulesGet: 'gatewayWrapperGql',
  AutoEnrollmentQuery: 'gatewayWrapperGql',
  OrganizationSkillSetsQuery: 'gatewayWrapperGql',
  PublicPromotionInfoProductItemFinder: 'gatewayWrapperGql',
  SgatewayWrapperGqlgatewayWrapperGqlnMetadataForSgatewayWrapperGqlgatewayWrapperGqlnRecommendations:
    'gatewayWrapperGql',
  SubscriptionTrials: 'gatewayWrapperGql',
  GetInstallmentLicenseCountQuery: 'gatewayWrapperGql',
  AutoenrolledCoursesQuery: 'gatewayWrapperGql',
  SessionsV2AuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  ObjectiveListQuery: 'gatewayWrapperGql',
  AuthoringWorkspaceTemplates: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataActivitySetEligibleTeamsQuery: 'gatewayWrapperGql',
  EnrollmentChoiceModalQuery: 'gatewayWrapperGql',
  AutoEnrollmentTriggersQuery: 'gatewayWrapperGql',
  CoursesNamesByIds: 'gatewayWrapperGql',
  ArticleEstimatedReadTimeQuery: 'gatewayWrapperGql',
  XdpSpecializationMetadataQuery: 'gatewayWrapperGql',
  GetProgramContractQuery: 'gatewayWrapperGql',
  EnterpriseBadgesCoursesSessionDatesQuery: 'gatewayWrapperGql',
  StaffSettingsInstructorProfilesQuery: 'gatewayWrapperGql',
  CourseSlugQuery: 'gatewayWrapperGql',
  FilterSessionsV2AuthoringEligibilityCheckQuery: 'gatewayWrapperGql',
  RatingQuery: 'gatewayWrapperGql',
  AutoEnrollmentCourseInfoQuery: 'gatewayWrapperGql',
  ProgramSummaryListContainerQuery: 'gatewayWrapperGql',
  ProgramsByOrgIdQuery: 'gatewayWrapperGql',
  PartnerPageQuery: 'gatewayWrapperGql',
  GetUserVerificationRequirements: 'gatewayWrapperGql',
  ProgramHomeModalManagerXdpQuery: 'gatewayWrapperGql',
  ClipsCourseDetailsQuery: 'gatewayWrapperGql',
  PrivateAuthoringPartnerIdQuery: 'gatewayWrapperGql',
  ForCreditCurriculumTracksByProgramQuery: 'gatewayWrapperGql',
  UnifiedCheckEnterpriseAdminRolesQuery: 'gatewayWrapperGql',
  LOHPDegreeListsV3Query: 'gatewayWrapperGql',
  FetchProductOverviewQueryVlp: 'gatewayWrapperGql',
  CollectionsQuery: 'gatewayWrapperGql',
  EnterpriseBrowseCollectionQuery: 'gatewayWrapperGql',
  DataProtectionQuery: 'gatewayWrapperGql',
  AccomplishmentsPaymentsCourseQuery: 'gatewayWrapperGql',
  AdminWorkspaceImages: 'gatewayWrapperGql',
  CertificateCode: 'gatewayWrapperGql',
  ProgramSkillsetsQuery: 'gatewayWrapperGql',
  CourseMetadataForCourseRecommendations: 'gatewayWrapperGql',
  DegreeHomeProgressQuery: 'gatewayWrapperGql',
  AuthoringTeamworkMetadataDeleteActivitySetQuery: 'gatewayWrapperGql',
  EnterpriseBadgeCoursesMultiGetQuery: 'gatewayWrapperGql',
  getLihpCourseData: 'gatewayWrapperGql',
  VLPFetchProductOverviewQuery: 'gatewayWrapperGql',
  UnifiedEnterpriseOpenCourseMembershipsQuery: 'gatewayWrapperGql',
  AdminDashboardPageQuery: 'gatewayWrapperGql',
  CollectionPageQuery: 'gatewayWrapperGql',
  SkillSetListQuery: 'gatewayWrapperGql',
  ProductsOwnedAndExpiredByIds: 'gatewayWrapperGql',
  UserActivePathway: 'gatewayWrapperGql',
  CoursesFinaid: 'gatewayWrapperGql',
  ProductPriceQuery: 'gatewayWrapperGql',
  TMRSummaryViewQuery: 'gatewayWrapperGql',
  getDegreeListsV3ByDomainQuery: 'gatewayWrapperGql',
  AssemblerAiProgramBuilderContext: 'gatewayWrapperGql',
  InternalPublicPromotionInfoLandingPageBannerFinder: 'gatewayWrapperGql',
  FirstNameQuery: 'gatewayWrapperGql',
  GetUpcomingCourseStatesQuery: 'gatewayWrapperGql',
  EnterpriseContractWithTagsQuery: 'gatewayWrapperGql',
  CreateTeamLearnersQuery: 'gatewayWrapperGql',
  degreeEnrollmentChecklistsVgatewayWrapperGqlQuery: 'gatewayWrapperGql',
  CatalogCollectionPageQuery: 'gatewayWrapperGql',
  OnDemandSpecializationForNonRecurring: 'gatewayWrapperGql',
  GdprMembershipQuery: 'gatewayWrapperGql',
  GetCourseForXdpEnrollCta: 'gatewayWrapperGql',
};

export default graphqlGatewayQueryLinkOverrideMap;
